import React, { useState, useEffect } from "react";
import Layout from "../../components/layout/Layout";
import { Link } from "react-router-dom";
import ViewStaff from "./ViewStaff";
import { connect, useDispatch, useSelector } from "react-redux";

import {
  staffList,
  staffsDelete,
  multiStaffDelete,
} from "../../redux/action/staff";
import { ToastContainer } from "react-toastify";
import { APIURL } from "../../redux/action/config";
import search from "../../utils/search";
import Pagination from "./../../components/Pagination";
import { CSVLink } from "react-csv";
import checklistIcon from "../../../src/assets/images/list-svgrepo-com1.svg";
import loader from "../../components/loader/loader";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import dateFormat from "dateformat";

const ManageList = ({ pageLoading, staffListData, not_found }) => {
  console.log(not_found, pageLoading, "pageLoading==");
  const [productDataList, setProductDataList] = useState([]);

  const onChangePage = (pageOfItems) => {
    setProductDataList(pageOfItems);
  };

  const headers = [
    { label: "_id", key: "id" },
    { label: "Name", key: "name" },
    { label: "Phone Number", key: "phone" },
    { label: "Email Address", key: "email" },
    { label: "Status", key: "status" },
    { label: "Image", key: "image" },
    { label: "Created_At", key: "created" },
    { label: "Updated_At", key: "updated" },
  ];

  const [id, setId] = useState();
  // const manageList = useSelector((state) => state?.staff?.list);
  const dispatch = useDispatch();
  const [viewDetails, setViewDetails] = useState();

  useEffect(() => {
    dispatch(staffList());
  }, [dispatch]);

  const handleGetId = (e, id) => {
    e.preventDefault();
    if (!id) return;
    if (id !== undefined) {
      const token = localStorage.getItem("token");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${APIURL}/api/v1/users/${id}`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          setViewDetails(result?.data);
        })
        .catch((error) => console.log("error", error));
    }
  };

  // const manageData = manageList?.data?.filteredUser
  //   ? manageList?.data?.filteredUser
  //   : "";
  const manageDel = async (id) => {
    const res = await dispatch(staffsDelete(id));
    console.log('res', res);
    if (res?.success) {
      setProductDataList(productDataList.filter((s) => s._id != id))
    }
    setTimeout(() => {
      dispatch(staffList());
    }, 1000);
  };

  // const data = productDataList
  //   ? productDataList?.map((item) => {
  //       return {
  //         id: item?._id,
  //         name:
  //           item?.firstName && item?.lastName
  //             ? `${item?.firstName ? item?.firstName : ""} ${
  //                 item?.lastName ? item?.lastName : ""
  //               }`
  //             : "N/A",
  //         phone: item?.phone ? item?.phone : "N/A",
  //         image: item?.image ? item?.image : "N/A",
  //         email: item?.email ? item?.email : "N/A",
  //         status: item?.status ? item?.status : "N/A",
  //         created: item?.createdAt ? item?.createdAt : "N/A",
  //         updated: item?.updatedAt ? item?.updatedAt : "N/A",
  //       };
  //     })
  //   : "";

  const getBadge = (status) => {
    switch (status) {
      case "available":
        return "success";
      case "busy":
        return "warning";
      default:
        return "primary";
    }
  };

  const [loading, setLoading] = React.useState(true);

  setTimeout(() => {
    setLoading(false);
  }, 2000);

  // *********** All Select Delete ***********
  const [btnStatus, setBtnStatus] = useState(false);
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);
  const [list, setList] = useState([]);

  useEffect(() => {
    setList(productDataList);
  }, [productDataList]);

  const handleSelectAll = (e) => {
    setIsCheckAll(!isCheckAll);
    setIsCheck(list.map((li) => li.id));
    if (isCheckAll) {
      setIsCheck([]);
    }
  };

  const handleClick = (e) => {
    const { id, checked } = e.target;
    setIsCheck([...isCheck, id]);
    if (!checked) {
      setIsCheck(isCheck.filter((item) => item !== id));
    }
  };

  const handleAllDelete = () => {
    multiStaffDelete(isCheck);
    setTimeout(() => {
      dispatch(staffList());
      setIsCheckAll(false);
      setIsCheck([]);
    }, 1000);
  };

  // Download csv files - export the selected rows, or the whole visible list if nothing is checked
  const seledCsvList =
    isCheck?.length > 0
      ? productDataList?.filter((item) => isCheck?.includes(item?.id))
      : productDataList;

  const data = seledCsvList
    ? seledCsvList?.map((item) => {
      return {
        id: item?._id,
        name:
          item?.firstName && item?.lastName
            ? `${item?.firstName ? item?.firstName : ""} ${item?.lastName ? item?.lastName : ""
            }`
            : "N/A",
        phone: item?.phone ? item?.phone : "N/A",
        image: item?.image ? item?.image : "N/A",
        email: item?.email ? item?.email : "N/A",
        status: item?.status ? item?.status : "N/A",
        created: item?.createdAt ? item?.createdAt : "N/A",
        updated: item?.updatedAt ? item?.updatedAt : "N/A",
      };
    })
    : "";

  // pdf code start
  const downloadPDF = () => {
    const capture = document.querySelector(".table");
    html2canvas(capture).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      console.log("Image Data:", imgData); // Debugging: Log the image data
      const doc = new jsPDF("p", "mm", "a4");
      const imgWidth = 200; // Adjust this based on your needs
      const imgHeight = (imgWidth * canvas.height) / canvas.width; // Maintain aspect ratio
      doc.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      doc.save("roadside-response.pdf");
    });
  };
  // pdf code end

  // date filter start
  const [filterDate, setFilterData] = useState({
    startDate: "",
    endDate: "",
  });

  const [listData, setListData] = useState([]);

  const startDate = filterDate?.startDate;
  const endDate = filterDate?.endDate;

  const handleOnchangeFilter = (e) => {
    const { name, value } = e.target;
    setFilterData({
      ...filterDate,
      [name]: value,
    });
  };

  const handleResetFilter = () => {
    setFilterData({ startDate: "", endDate: "" });
  };

  useEffect(() => {
    if (!staffListData) return;
    if (!startDate && !endDate) {
      setListData(staffListData);
      return;
    }
    const filteredDataList = staffListData?.filter((obj) => {
      const objDate = dateFormat(obj.createdAt, "yyyy-mm-dd");
      return (!startDate || objDate >= startDate) && (!endDate || objDate <= endDate);
    });
    setListData(filteredDataList);
  }, [staffListData, startDate, endDate]);
  // date filter End

  console.log("====================================");
  console.log(productDataList, "productDataList");
  console.log("====================================");
  return (
    <React.Fragment>
      <ToastContainer autoClose={2000} />
      <Layout title="Staffs List" page="staff">
        <div
          className="content d-flex flex-column flex-column-fluid"
          id="kt_content"
        >
          <div id="kt_content_container" className="container-fluid">
            <div className="row g-5 g-xxl-10">
              <div className="col-xl-12 col-xxl-12 mb-5 mb-xxl-12">
                <div
                  id="kt_datatable_example_5_wrapper"
                  className="dataTables_wrapper dt-bootstrap4 no-footer"
                >
                  <div
                    className="content d-flex flex-column flex-column-fluid"
                    id="kt_content"
                  >
                    <div id="kt_content_container" className="container-fluid">
                      <div className="row pt-4 pb-4">
                        <div className="col-sm-6 d-flex align-items-center justify-conten-start">
                          <div
                            className="dataTables_length"
                            id="kt_datatable_example_5_length"
                          >
                            <div className="filter-table-data ml-5 d-flex align-items-center">
                              {isCheck && isCheck?.length > 0 ? (
                                <button
                                  onClick={() => {
                                    handleAllDelete();
                                  }}
                                  className="delete-selected me-4"
                                >
                                  Delete Selected
                                </button>
                              ) : (
                                ""
                              )}
                              <div className="">
                                <input
                                  className="form-control"
                                  name="startDate"
                                  type="date"
                                  value={startDate}
                                  onChange={(e) => {
                                    handleOnchangeFilter(e);
                                  }}
                                />
                              </div>
                              <span className="mx-4 fw-bolder">To</span>
                              <div>
                                <input
                                  className="form-control"
                                  name="endDate"
                                  type="date"
                                  min={startDate || ""}
                                  value={endDate}
                                  onChange={(e) => {
                                    handleOnchangeFilter(e);
                                  }}
                                />
                              </div>
                              {(startDate || endDate) ? (
                                <button
                                  type="button"
                                  className="btn btn-light-danger ms-2"
                                  onClick={handleResetFilter}
                                >
                                  Reset
                                </button>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 d-flex align-items-center justify-content-end">
                          <div
                            id="kt_datatable_example_5_filter"
                            className="dataTables_filter"
                          >
                            <label>
                              Search:
                              <input
                                type="search"
                                onChange={() => {
                                  search();
                                }}
                                id="myInput"
                                className="form-control form-control-sm form-control-solid"
                                placeholder=""
                                aria-controls="kt_datatable_example_5"
                              />
                            </label>
                          </div>
                          <div className="ms-3">
                            <a
                              className="btn pgf btn-secondary dropdown-toggle"
                              href="#"
                              // role="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              // className="csvlink"
                              style={{ background: "none" }}
                            >
                              Download File
                            </a>

                            <ul className="dropdown-menu">
                              <li>
                                <a className="dropdown-item">
                                  <CSVLink
                                    style={{ color: "#000" }}
                                    data={data}
                                    headers={headers}
                                  >
                                    Download as CSV
                                  </CSVLink>
                                </a>
                              </li>
                              <li>
                                <a className="dropdown-item" onClick={downloadPDF}>
                                  Download as PDF
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="row g-5 g-xxl-10">
                        <div className="col-xl-12 col-xxl-12 mb-5 mb-xxl-12">
                          <div className="table-responsive table-wrapper">
                            <table
                              id="kt_datatable_example_5"
                              className="table table-striped table-row-bordered gy-5 gs-7 border rounded dataTable no-footer status"
                            >
                              <thead>
                                <tr className="fw-bolder fs-6 text-gray-800 px-7 arrow-none">
                                  {/* <th style={{ width: "113.062px" }}>
                                    Staff Code
                                  </th> */}
                                  {/* <th style={{ width: "142.125px" }}>
                                    Profile Picture
                                  </th> */}
                                  <th style={{ padding: "16px 0px 16px 24px" }}>
                                    <input
                                      type="checkbox"
                                      name="selectAll"
                                      id="selectAll"
                                      onClick={() => {
                                        handleSelectAll();
                                        setBtnStatus(true);
                                      }}
                                      checked={isCheckAll}
                                      className="form-check-input custum-check"
                                    />
                                  </th>
                                  <th style={{ width: "101.969px" }}>
                                    First Name
                                  </th>
                                  <th style={{ width: "148.391px" }}>
                                    Phone Number
                                  </th>
                                  <th style={{ width: "180.078px" }}>
                                    Email Address
                                  </th>
                                  {/* <th style={{ width: "146.906px" }}>
                                    Designation
                                  </th>
                                  <th style={{ width: "114.844px" }}>
                                    Experience
                                  </th> */}
                                  <th style={{ width: "63.156px" }}>Status</th>
                                  <th style={{ width: "199.875px" }}>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {!pageLoading && productDataList?.length ? (
                                  productDataList?.map((item, index) => {
                                    return (
                                      <tr key={index}>
                                        {/* <td>{item.id}</td> */}
                                        {/* <td>
                                          <img
                                            src={
                                              item.image ? item.image : profile
                                            }
                                            alt="profile"
                                          />
                                        </td> */}
                                        <td
                                          style={{ width: "20px" }}
                                          className="check-list"
                                        >
                                          <input
                                            type="checkbox"
                                            name={item?.firstName}
                                            id={item?.id}
                                            onClick={(e) => handleClick(e)}
                                            checked={isCheck.includes(item?.id)}
                                            className="form-check-input custum-check"
                                          />
                                        </td>
                                        <td>{item.firstName}</td>
                                        <td>{item.phone}</td>
                                        <td>{item.email}</td>
                                        {/* <td>{item.designation}</td>
                                        <td>{item.experience}</td> */}
                                        <td>
                                          <span
                                            className={`btn ${getBadge(
                                              item.status
                                            )} text-capitalize`}
                                          >
                                            {item.status}
                                          </span>
                                        </td>
                                        <td>
                                          <Link
                                            onClick={() => setId(item.id)}
                                            to={`/view-checklists/${item.id}`}
                                            className="btn btn-bg-primary action-hover"
                                          >
                                            <img
                                              src={checklistIcon}
                                              alt="checklistIcon"
                                              style={{
                                                width: "16px",
                                                height: "20px",
                                              }}
                                            />
                                          </Link>
                                          {/* <Link
                                            to="#"
                                            onClick={() => setId(item.id)}
                                            className="btn btn-bg-primary action-hover"
                                            data-bs-toggle="modal"
                                            data-bs-target="#staffDetailModal"
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              fill="currentColor"
                                              className="bi bi-eye-fill"
                                              viewBox="0 0 16 16"
                                            >
                                              <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                                              <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                                            </svg>
                                          </Link> */}
                                          <a
                                            type="button"
                                            onClick={(e) =>
                                              handleGetId(e, item?.id)
                                            }
                                            className="btn btn-primary"
                                            data-bs-toggle="modal"
                                            data-bs-target="#staffDetailModal"
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              fill="currentColor"
                                              className="bi bi-eye-fill"
                                              viewBox="0 0 16 16"
                                            >
                                              <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                                              <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                                            </svg>
                                          </a>
                                          <ViewStaff
                                            modalId={"staffDetailModal"}
                                            viewDetails={viewDetails}
                                          />
                                          <Link
                                            to={`/edit-staff/${item.id}`}
                                            onClick={() => setId(item.id)}
                                            className="btn btn-info action-hover"
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              fill="currentColor"
                                              className="bi bi-pencil-square"
                                              viewBox="0 0 16 16"
                                            >
                                              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                              <path
                                                fillRule="evenodd"
                                                d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                                              />
                                            </svg>
                                          </Link>
                                          <Link
                                            to="/manage-staff"
                                            onClick={() => manageDel(item.id)}
                                            className="btn btn-bg-dark action-hover"
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              fill="currentColor"
                                              className="bi bi-trash-fill"
                                              viewBox="0 0 16 16"
                                            >
                                              <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                                            </svg>
                                          </Link>
                                        </td>
                                      </tr>
                                    );
                                  })
                                ) : (
                                  <div className="spinner-outer p-5">
                                    {pageLoading == true ? (
                                      <div className="spinner-outer p-5">
                                        {loader()}
                                      </div>
                                    ) : (
                                      <p>Data not found</p>
                                    )}
                                  </div>
                                )}
                              </tbody>
                            </table>
                          </div>
                          {listData && listData ? (
                            <Pagination
                              pageSize={10}
                              items={listData}
                              onChangePage={onChangePage}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  pageLoading: state?.staff?.loading,
  staffListData: state?.staff?.list,
  not_found: state?.staff?.not_found,
});
export default connect(mapStateToProps, { staffList })(ManageList);
